<script setup>
import { computed } from 'vue';
import Link from '@components/link.vue';
import Icon from '@components/icons/icon.vue';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    route: {
        type: Object,
        default: null,
    },
    menuLevel: {
        type: Number,
        required: true,
    },
    active: {
        type: Boolean,
        required: true,
    },
    selected: {
        type: Boolean,
        required: true,
    },
    hasNoChildren: {
        type: Boolean,
        required: true,
    },
    activeSearch: {
        type: Boolean,
        required: true,
    },
});

const color = computed(() => (props.menuLevel - 1) * 2 / 10);
const hoverColor = computed(() => props.menuLevel * 2 / 10);
const searchSelectedColor = computed(() => props.menuLevel * 2 / 10);
const searchSelectedHoverColor = computed(() => (props.menuLevel + 1) * 2 / 10);
</script>

<template>
    <p
        v-if="title !== null"
        :style="'--color:' + color + ';--hoverColor:' + hoverColor + ';--searchSelectedColor:' + searchSelectedColor + ';--searchSelectedHoverColor:' + searchSelectedHoverColor"
        :class="[
            $style.menu_item,
            selected && !hasNoChildren ? (!activeSearch || menuLevel === 1 ? $style.primary__selected : $style.secondary_selected) : '',
            active ? $style.active : '',
            menuLevel > 1 ? $style.child : '',
        ]"
    >
        <Link
            v-if="route !== null"
            :route="route"
            :highlight-on-hover="false"
            spread
        >
            <span :class="$style.title">
                {{ title }}
                <Icon v-if="active" icon="map-marker-alt" icon-color="white"/>
            </span>
        </Link>
        <span v-else :class="$style.title">
            {{ title }}
            <Icon :icon="active ? 'minus' : (selected ? 'chevron-down' : 'chevron-right')" icon-color="white"/>
        </span>
    </p>
</template>

<style lang="scss" module>
@use '@text' as *;
@use '@backgrounds' as *;
@use '@sizes' as *;

.menu_item {
    background-color: rgba(0,0,0,var(--color));
    &:hover {
       cursor: default;

        * {
            cursor: inherit;
        }
    }
    &:hover:not(
        .active
    ) {
        cursor: pointer;
    }
    &:hover:not(
        .active,
        .primary__selected
    ) {
        background-color: rgba(0,0,0,var(--hoverColor));
    }
    &.primary__selected,
    &.active {
        background-color: $primary-background-dark-mode;
    }
    &.secondary_selected {
        background-color: rgba(0,0,0,var(--searchSelectedColor));

        &:hover {
            background-color: rgba(0,0,0,var(--searchSelectedHoverColor));
        }
    }
    .title {
        display: flex;
        width: 100%;
        column-gap: .7em;
        align-items: center;
        justify-content: space-between;
        padding: .85em 1em .85em 1.25em;
        line-height: 1.3;
        color: #fff;
    }
    &.child {
        border-left: 4px solid $primary-background-dark-mode;
    }
}
</style>
